import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import NoMatch from "./pages/no-match";
import RescueNew from "./pages/rescue-new";
import HomeNew from "./pages/rescue-new/home";
import ContextProvider from "./pages/rescue/components/ContextProvider";
import ContextProviderNew from "./pages/rescue-new/components/ContextProvider";
import Octopus from "./pages/octopus";
import WorkUpload from "./pages/work-upload";
import Rules from "./pages/rules";

function App() {
  return (
    <ContextProviderNew>
      <ContextProvider>
        <Switch>
          <Redirect path="/" exact to="/home-new" />
          <Redirect path="/home" exact to="/home-new" />
          <Route path="/home-new">
            <HomeNew />
          </Route>
          <Route path="/rescue-new">
            <RescueNew></RescueNew>
          </Route>
          <Route path="/rules">
            <Rules></Rules>
          </Route>
          <Route path="/octopus/:token">
            <Octopus />
          </Route>
          <Route path="/work-upload/:token">
            <WorkUpload />
          </Route>
          <Route>
            <NoMatch />
          </Route>
        </Switch>
      </ContextProvider>
    </ContextProviderNew>
  );
}

export default App;
